<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-datepicker
      data-testid="technical-inspection-expiry-date-datepicker"
      [formControl]="controls.technicalInspectionExpiryDate"
      label="labels.technicalInspectionExpiryDate"
      [yearsRange]="{ past: 0, future: 10 }"
      [warningTypes]="['pastDate']"
      [size]="32"
    ></onyx-datepicker>

    <onyx-upload
      data-testid="registration-certificate-scan-upload"
      [formControl]="controls.scan"
      label="labels.registrationCertificateScan"
      [limit]="2"
      [size]="32"
    ></onyx-upload>
  </form>
</onyx-section>
